module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Remembering Farley")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "style.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("I see that it’s taking all her strength to keep from\n  leaping up and helping the waitress clear the table.")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("I see how much she wants to run back into the\nrestaurant’s kitchen and wash the pans.")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("I see that she’s worried about the busboy’s tired\narms, the cashier’s tired feet, and that it’s all she can do\nto not take the rest of her meal out to that “nice young\nman parking the cars.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a50a4b40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mom006.vue
// module id = 69
// module chunks = 0